/**
 * Which message a refused voucher shows at checkout (#3332 D7). The backend
 * names why a found code may not be spent (`VoucherRefusedError` in the Lambda
 * voucher service); everything else — an unknown code, another location, a
 * code at its limit — stays the generic "invalid coupon".
 */
const REFUSAL_KEYS: Record<string, string> = {
  frozen: "book_location.error.voucher_frozen",
  expired: "book_location.error.voucher_expired",
  used_up: "book_location.error.voucher_used_up",
  refunded: "book_location.error.voucher_refunded",
};

const INVALID_KEY = "book_location.error.invalid_coupon";

/** The error body, whether axios parsed it or left the JSON string. */
const bodyOf = (error: unknown): unknown => {
  const data = (error as { data?: unknown } | null)?.data;
  if (typeof data !== "string") return data;
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
};

export const voucherRefusalMessageKey = (error: unknown): string => {
  const reason = (bodyOf(error) as { reason?: unknown } | null)?.reason;
  return typeof reason === "string" && REFUSAL_KEYS[reason] ? REFUSAL_KEYS[reason] : INVALID_KEY;
};
